/* eslint-disable react/prop-types */
import React from 'react';
import Button from 'react-bootstrap/Button';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { func, string } from 'prop-types';

export const SaveButton = (props) => {
  const { size = 'sm', variant = 'primary', className = '', onClick = () => {}, btnText = 'Save' } = props;
  return (
    <Button size={size} variant={variant} className={className} onClick={onClick}>
      <FaCheck className={'mb-1 mr-1'} />
      {btnText}
    </Button>
  );
};

SaveButton.prototype = {
  size: string,
  variant: string,
  className: string,
  onClick: func,
};

export const CloseButton = (props) => {
  const { size = 'sm', variant = 'fff', className = '', onClick = () => {}, btnText = 'Close' } = props;
  return (
    <Button size={size} variant={variant} className={className} onClick={onClick}>
      <FaTimes className={'mb-1 mr-1'} />
      {btnText}
    </Button>
  );
};

CloseButton.prototype = {
  size: string,
  variant: string,
  className: string,
  onClick: func,
};
